import React from 'react';
import { motion } from 'framer-motion';
import { Reveal } from '../fx/Reveal';
const stats = [{
  value: '24/7',
  label: 'Emergency Response'
}, {
  value: '2,000+',
  label: 'Homes Restored'
}, {
  value: '60min',
  label: 'Avg. Response Time'
}, {
  value: '5.0',
  label: 'Google Rating'
}];
export function StatsBand() {
  return <section className="relative mx-auto max-w-6xl px-6 py-12" data-id="element-312" data-mp="2o68zly9baylf">
      <div className="glass-strong grid grid-cols-2 gap-6 rounded-[2.5rem] px-8 py-10 shadow-glass md:grid-cols-4" data-id="element-313" data-mp="2o4o8kim7hxsb">
        {stats.map((s, i) => <Reveal key={s.label} delay={i * 0.1} className="text-center" data-id="element-314" data-mp="2f62qeokncks2" data-mpi={i}>
            <motion.p className="font-display text-3xl font-bold text-gradient sm:text-4xl" initial={{
          scale: 0.6
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          type: 'spring',
          stiffness: 200,
          damping: 14,
          delay: i * 0.1
        }} data-id="element-315" data-mp="2f7xe2anayqzu">
              {s.value}
            </motion.p>
            <p className="mt-2 text-xs font-medium uppercase tracking-wider text-slate" data-id="element-316" data-mp="10o26t1xyrj33">
              {s.label}
            </p>
          </Reveal>)}
      </div>
    </section>;
}